<div class="container-fluid login">
    <div class="login-background"></div>
    <div class="login-background-overlay"></div>
    <div class="row login-logo">
        <div class="col-12 m-auto h-100 text-center">
            <img
                class="mh-100 mw-100"
                src="assets/compas_lato_white.svg"
                alt
                role="presentation"
            />
        </div>
    </div>
    <cmps-client-logo [login]="true"></cmps-client-logo>

    <cmps-wait-status
        [fixed]="true"
        [modal]="true"
    ></cmps-wait-status>
</div>
